export default "__VITE_ASSET__CzwUy6nK__"